module.exports = __webpack_public_path__ + "img/2024_CellSystems.0e50e7f1.png";